import React, { Component } from 'react';
import TenderSmall from './TenderSmall';
import { GetData } from '../../api/Service';

class TenderList extends Component {
    constructor(Props) {
        super(Props);
        this.state = {
            news: [],
            news_det: []
        }
    }

    componentDidMount() {
        var url = "http://192.168.43.104:5000/api/tender/1/10";
        /* fetch(url).then(resp => resp.json())
            .then(json => {
                this.setState({
                    news: json.rows,
                    news_det: json.b_arr
                })
            }); */

        GetData('api/tender/1/20')
            .then(json => {
                //console.log(json);
                this.setState({
                    news: json.rows.map(el => {
                        return {
                            ...el,
                            description: JSON.parse(el.description),
                            uploadInfo: JSON.parse(el.uploadInfo)
                        }
                    }),
                    news_det: json.b_arr
                })
            });
    }
    editClick(value) {
        this.props.onEditClick(value);
    }

    onDeleteClick(id) {
        this.props.onDeleteClick(id);
    }
  render() {
      let n = this.state.news;
      let m = n.map((nn, index) =>
          <TenderSmall key={index} editClick={this.editClick.bind(this, nn)} message={nn.message} onDeleteClick={this.onDeleteClick.bind(this, nn.id)} title={nn.title} id={nn.id} description={nn.description} date={nn._date_} uploadInfo={nn.uploadInfo} />
      );
    return (
        <div className="notice-list">
            <div>
                {m}
            </div>
        </div>
    )
  }
}


export default  TenderList;


// WEBPACK FOOTER //
// ./src/HomeComponents/Tender/TenderList.jsx